import { Place } from "@mui/icons-material";
import { Stack, StackProps } from "@mui/material";
import { Location } from "graphql/generated/types";

export type EventCardLocationProps = { location: Pick<Location, "formattedAddress"> | null | undefined } & StackProps

export const EventCardLocation: React.FC<EventCardLocationProps> = ({ location, ...props }) => {
    if (!location) return null;
    
    return (
        <Stack direction="row" spacing={0.5} alignItems="center" data-testid="event-card-location" {...props}>
            <Place fontSize='small' />
            <div>{location.formattedAddress}</div>
        </Stack>
    );
}; 
